module.exports = __webpack_public_path__ + "media/advanced_misty3.7f44c926.mp4";